import { CheckCircle, XCircle } from "lucide-react";

const ACCEPTED = [
  "Unopened, sealed boxes only",
  "Boxes in good condition",
  "Not expired (at least 6 months remaining)",
  "Most major brands accepted"
];

const REJECTED = [
  "Boxes labeled Medicaid or Medicare",
  "Opened or damaged boxes",
  "Expired test strips",
  "Boxes with missing seals",
  "Water-damaged packaging"
];

export const Requirements = () => (
  <section id="requirements" className="py-24 md:py-32 bg-[#0F5132] noise-overlay relative" data-testid="requirements-section">
    <div className="container-custom relative z-10">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-white mb-4" style={{ fontFamily: "Manrope" }}>
          What We Accept
        </h2>
        <p className="text-lg text-white/80 max-w-2xl mx-auto">
          To ensure quality, we have a few simple requirements for the test strips we purchase.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-3" style={{ fontFamily: "Manrope" }}>
            <CheckCircle className="w-6 h-6 text-green-400" />
            We Accept
          </h3>
          <ul className="space-y-4">
            {ACCEPTED.map((item) => (
              <li key={item} className="flex items-start gap-3 text-white/90">
                <CheckCircle className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-3" style={{ fontFamily: "Manrope" }}>
            <XCircle className="w-6 h-6 text-red-400" />
            We Cannot Accept
          </h3>
          <ul className="space-y-4">
            {REJECTED.map((item) => (
              <li key={item} className="flex items-start gap-3 text-white/90">
                <XCircle className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
